module.exports = __webpack_public_path__ + "static/assets/58d1104d0922e424a0b0d4a27e6ed826.svg";